import * as types from 'constants/ActionTypes';
import { GET_PAGINATED_DEALERS_FETCH_SUCCESS } from 'modules/dealers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

// Contains all dealer ids that are currently displayed in the table of the administration dealers screen
/** @typedef {Array<string>} State */
/** @type {State} */
const initialState = [];

/** @returns {State} */
const fetchDealersFailureReducer = () => initialState;

/**
 *
 * @param {State} state
 * @param {import('modules/dealers/types').GenericDealersActionPage} action
 * @returns {State}
 */
const fetchDealersSuccessReducer = (_, { payload }) => payload.content.map(dealer => dealer.id);

const dealerSuccessReducer = (state, { payload: dealer }) => [...state, dealer.id];

export default createReducer(initialState, {
  [GET_PAGINATED_DEALERS_FETCH_SUCCESS]: fetchDealersSuccessReducer,
  [types.FETCH_DEALERS_FAILURE]: fetchDealersFailureReducer,
  [types.FETCH_DEALERS_SUCCESS]: fetchDealersSuccessReducer,
  [types.CREATE_DEALER_SUCCESS]: dealerSuccessReducer,
});
